import { useFormikContext } from 'formik'
import { usePrevilegies } from 'hooks/usePrevilegies'
import Checkbox from 'ui/components/forms/Checkbox'
import { CheckboxesWrapper } from './styled'

export const ProjectPermUser = ({ canEditProjectSettings = true }) => {
  const formik = useFormikContext()
  const { isAdmin } = usePrevilegies()

  return (
    <CheckboxesWrapper>
      <Checkbox
        label="Проект тех. поддержки"
        checked={formik.getFieldProps('is_tech_support').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('is_tech_support')}
      />
      <Checkbox
        label="Участники могут назначать задачи на себя"
        checked={formik.getFieldProps('perm_user_self_assign').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_user_self_assign')}
      />
      <Checkbox
        label="Участники могут создавать задачи"
        checked={formik.getFieldProps('perm_user_create_task').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_user_create_task')}
      />
      <Checkbox
        label="Менеджер считается админом"
        checked={formik.getFieldProps('perm_manager_is_admin').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_manager_is_admin')}
      />
      {isAdmin && (
        <Checkbox
          label="Менеджер может ставить &laquo;супер&nbsp;задачу&raquo;"
          checked={formik.getFieldProps('perm_manager_create_supertask').value}
          disabled={!canEditProjectSettings}
          {...formik.getFieldProps('perm_manager_create_supertask')}
        />
      )}
      <Checkbox
        label="Эпик обязателен для задач"
        checked={formik.getFieldProps('perm_epic_required').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_epic_required')}
      />
      <Checkbox
        label="Исполнитель может добавлять свою оценку в диаграмму ганта"
        checked={formik.getFieldProps('perm_user_self_estimate').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_user_self_estimate')}
      />
      <Checkbox
        label="Менеджер может редактировать эпик задач"
        checked={formik.getFieldProps('perm_manager_edit_epic').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_manager_edit_epic')}
      />
      <Checkbox
        label="Участники могут переводить задачи в &laquo;готово к&nbsp;тестированию&raquo;"
        checked={formik.getFieldProps('perm_user_to_rft').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('perm_user_to_rft')}
      />
      <Checkbox
        label="Нельзя брать в работу задачи без оценки исполнителя"
        checked={formik.getFieldProps('is_responsible_estimate_required').value}
        disabled={!canEditProjectSettings}
        {...formik.getFieldProps('is_responsible_estimate_required')}
      />
    </CheckboxesWrapper>
  )
}
